import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { NotPersistAction } from "store/actions";
import C from "Constants";
import { useLang } from "hooks";
import { useCustomHistory } from "hooks";
import useQueryParam from "modules/dine-in/useQueryParam";
import useEventTracker from "hooks/useEventTracker";
import { PageHeaderV2 } from "components/PageHeader";
import { TranslationText } from "components/TextTranslationContainer";
import { CustomButton } from "components/Button";

function OrderPlaced(props) {
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const router = useCustomHistory();
  const { currentLang } = useLang();
  const queryParam = useQueryParam();
  const [shopUrl, setShopUrl] = useState(null);
  const { DomainType, orderType } = useSelector((state) => state.AppReducer);
  const { brandInfo } = useSelector((state) => state?.brandStorageReducer);

  useEventTracker({ name: "ORDER_PLACED", shouldLog: true, orderType: null });
  useEventTracker({ name: "ORDER_PLACED", shouldLog: true, orderType });

  const share = (DOMAIN_NAME, url) => {
    dispatch(NotPersistAction.toggleOrderPlaceModel(false));
    const message = `Hi, I have just ordered from ${brandInfo?.brand?.brandName} You can also avail BIG discounts as soon as you place your first order. ${url} `;
    window.open(`https://wa.me/?text=${message}`, "_blank");
  };

  const goToDineHomePage = (url) => {
    history.push({
      pathname: url,
      search: queryParam,
    });
  };

  const shareOnWhatsapp = () => {
    if (DomainType === C.TEMPORARAY_DOMAIN) {
      const DOMAIN_NAME = params?.domainName;
      let url = C.PAYMENT_REDIRECT_URL + DOMAIN_NAME;
      share(DOMAIN_NAME, url);
      if (DOMAIN_NAME) {
        if (orderType?.serviceType === C.SERVICE_TYPE.DINE_IN) {
          goToDineHomePage(`/${DOMAIN_NAME}/dine-in`);
        } else {
          history.push(`/${DOMAIN_NAME}/`);
        }
      }
    } else {
      let url = C.PAYMENT_REDIRECT_URL || "";
      share(brandInfo.brand?.brandName, url);
      if (orderType?.serviceType === C.SERVICE_TYPE.DINE_IN) {
        goToDineHomePage(`/dine-in`);
      } else {
        history.push(`/`);
      }
    }
  };

  useEffect(() => {
    if (brandInfo?.storeFrontURL) {
      setShopUrl(brandInfo.storeFrontURL);
    }
  }, []);

  const goBack = () => {
    dispatch(NotPersistAction.toggleOrderPlaceModel(false));
    if (props?.gotoHomePage) {
      props.gotoHomePage();
    } else {
      router("/", `/${params?.domainName}`, DomainType);
    }
  };

  return (
    <div className="relative flex flex-col gap-8 items-center">
      <PageHeaderV2
        pageTitle={"Confirmation"}
        authClick={props?.goToLogin}
        userClick={props?.goToSettings}
        onGoBack={goBack}
        containerStyleProps={{
          className: "relative",
        }}
        hideAuth={!props?.goToLogin && !props?.goToSettings}
      />
      <div className="flex flex-col gap-6 items-center">
        <svg
          width="173"
          height="151"
          viewBox="0 0 173 151"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="primary-svg-stroke"
        >
          <path
            d="M94 137.5C128.375 137.5 156.5 109.375 156.5 75C156.5 40.625 128.375 12.5 94 12.5C59.625 12.5 31.5 40.625 31.5 75C31.5 109.375 59.625 137.5 94 137.5Z"
            stroke="#FE5900"
            strokeWidth="9.375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M67.4375 75L85.125 92.6875L120.562 57.3125"
            stroke="#FE5900"
            strokeWidth="9.375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17 117L20.1855 130.814L34 134L20.1855 137.186L17 151L13.8145 137.186L0 134L13.8145 130.814L17 117Z"
            fill="#FFDE4D"
          />
          <path
            d="M35 5.5L37.3423 15.6577L47.5 18L37.3423 20.3423L35 30.5L32.6577 20.3423L22.5 18L32.6577 15.6577L35 5.5Z"
            fill="#FFDE4D"
          />
          <path
            d="M165 34.5L166.405 40.5946L172.5 42L166.405 43.4054L165 49.5L163.595 43.4054L157.5 42L163.595 40.5946L165 34.5Z"
            fill="#FFDE4D"
          />
        </svg>
        <TranslationText
          text={"Thank you for your Order"}
          className="text-24x font-bold text-shadow-forge-900"
        />
      </div>
      <div className="absolute bottom-0 left-0 right-0 z-50 bg-dark-blue-100 p-6 flex flex-col gap-2">
        <CustomButton onClick={props?.trackOrder}>
          <TranslationText text={"Track Order"} />
        </CustomButton>
        {shopUrl && (
          <CustomButton outline onClick={shareOnWhatsapp}>
            <TranslationText text={"Share with Friends"} />
          </CustomButton>
        )}
      </div>
    </div>
  );
}

export default OrderPlaced;
